import type { ComponentType } from 'react';
import type {
  CardSectionProps,
  DepoimentoSectionProps,
  EmpresaSectionProps,
  EquipeSectionProps,
  HeroSectionProps,
  RodapeSectionProps,
  TopoSectionProps,
} from './types';
import WelcomeReserva from '../pieces/welcome-reserva/WelcomeReserva';
import WelcomeDwello from '../pieces/welcome-dwello/WelcomeDwello';
import WelcomePadraoIa from '../pieces/welcome-padrao-ia/WelcomePadraoIa';
import WelcomeAutoral from '../pieces/welcome-autoral/WelcomeAutoral';
import WelcomeCarrosselIa from '../pieces/welcome-carrossel-ia/WelcomeCarrosselIa';
import TopoAutoral from '../pieces/topo-autoral/TopoAutoral';
import AutoralFooter from '../pieces/autoral-footer/AutoralFooter';
import EmpresaAutoral from '../pieces/empresa-autoral/EmpresaAutoral';
import TopoAurora from '../pieces/topo-aurora/TopoAurora';
import WelcomeAurora from '../pieces/welcome-aurora/WelcomeAurora';
import CardAurora from '../carousel/apartment/CardAurora';
import AuroraFooter from '../pieces/aurora-footer/AuroraFooter';
import dynamic from 'next/dynamic';

// Horizonte (modelo pronto #8): as 4 peças vêm por next/dynamic com import() LITERAL, cada uma no
// seu chunk — só os sites que usam o modelo baixam o código (import estático punha +50 KB gzip na
// home de TODOS os sites). Com o import() literal o SWC gera o loadableGenerated: o SSR registra o
// chunk, o HTML já o pré-carrega e a hidratação espera por ele (sem #418/#423). O que o README
// desaconselha é o import() embrulhado num helper (lazySection), que perde esse rastreio.
const TopoHorizonte = dynamic(() => import('../pieces/topo-horizonte/TopoHorizonte'), { ssr: true });
const WelcomeHorizonte = dynamic(() => import('../pieces/welcome-horizonte/WelcomeHorizonte'), { ssr: true });
const CardHorizonte = dynamic(() => import('../carousel/apartment/CardHorizonte'), { ssr: true });
const HorizonteFooter = dynamic(() => import('../pieces/horizonte-footer/HorizonteFooter'), { ssr: true });
// Atelier (modelo pronto #9): mesmo esquema do Horizonte — next/dynamic com import() LITERAL, um
// chunk por peça, só para quem usa os números novos (topo 12 · busca 15 · card 9 · rodapé 9).
const TopoAtelier = dynamic(() => import('../pieces/topo-atelier/TopoAtelier'), { ssr: true });
const WelcomeAtelier = dynamic(() => import('../pieces/welcome-atelier/WelcomeAtelier'), { ssr: true });
const CardAtelier = dynamic(() => import('../carousel/apartment/CardAtelier'), { ssr: true });
const AtelierFooter = dynamic(() => import('../pieces/atelier-footer/AtelierFooter'), { ssr: true });
// Panorama (modelo pronto #10): mesmo esquema — next/dynamic com import() LITERAL, um chunk por
// peça, só para quem usa os números novos (topo 13 · busca 16 · card 10 · rodapé 10).
const TopoPanorama = dynamic(() => import('../pieces/topo-panorama/TopoPanorama'), { ssr: true });
const WelcomePanorama = dynamic(() => import('../pieces/welcome-panorama/WelcomePanorama'), { ssr: true });
const CardPanorama = dynamic(() => import('../carousel/apartment/CardPanorama'), { ssr: true });
const PanoramaFooter = dynamic(() => import('../pieces/panorama-footer/PanoramaFooter'), { ssr: true });
// Larissa (modelo pronto #11): mesmo esquema — next/dynamic com import() LITERAL, um chunk por peça,
// só para quem usa os números novos (topo 14 · busca 17 · card 11 · rodapé 11).
const TopoLarissa = dynamic(() => import('../pieces/topo-larissa/TopoLarissa'), { ssr: true });
const WelcomeLarissa = dynamic(() => import('../pieces/welcome-larissa/WelcomeLarissa'), { ssr: true });
const CardLarissa = dynamic(() => import('../carousel/apartment/CardLarissa'), { ssr: true });
const LarissaFooter = dynamic(() => import('../pieces/larissa-footer/LarissaFooter'), { ssr: true });
// Metrópole (modelo pronto #12): mesmo esquema — next/dynamic com import() LITERAL, um chunk por peça,
// só para quem usa os números novos (topo 15 · busca 18 · card 12 · rodapé 12).
const TopoMetropole = dynamic(() => import('../pieces/topo-metropole/TopoMetropole'), { ssr: true });
const WelcomeMetropole = dynamic(() => import('../pieces/welcome-metropole/WelcomeMetropole'), { ssr: true });
const CardMetropole = dynamic(() => import('../carousel/apartment/CardMetropole'), { ssr: true });
const MetropoleFooter = dynamic(() => import('../pieces/metropole-footer/MetropoleFooter'), { ssr: true });
// Internacional (modelo pronto #12): mesmo esquema — next/dynamic com import() LITERAL, um chunk por peça,
// só para quem usa os números novos (topo 16 · busca 19 · card 13 · rodapé 13).
const TopoInternacional = dynamic(() => import('../pieces/topo-internacional/TopoInternacional'), { ssr: true });
const WelcomeInternacional = dynamic(() => import('../pieces/welcome-internacional/WelcomeInternacional'), { ssr: true });
const CardInternacional = dynamic(() => import('../carousel/apartment/CardInternacional'), { ssr: true });
const InternacionalFooter = dynamic(() => import('../pieces/internacional-footer/InternacionalFooter'), { ssr: true });
// Norte (modelo pronto #13): mesmo esquema — next/dynamic com import() LITERAL, um chunk por peça,
// só para quem usa os números novos (topo 17 · busca 20 · card 14 · rodapé 14).
const TopoNorte = dynamic(() => import('../pieces/topo-norte/TopoNorte'), { ssr: true });
const WelcomeNorte = dynamic(() => import('../pieces/welcome-norte/WelcomeNorte'), { ssr: true });
const CardNorte = dynamic(() => import('../carousel/apartment/CardNorte'), { ssr: true });
const NorteFooter = dynamic(() => import('../pieces/norte-footer/NorteFooter'), { ssr: true });
// Campo (modelo pronto #14): mesmo esquema — next/dynamic com import() LITERAL, um chunk por peça,
// só para quem usa os números novos (topo 18 · busca 21 · card 15 · rodapé 15).
const TopoCampo = dynamic(() => import('../pieces/topo-campo/TopoCampo'), { ssr: true });
const WelcomeCampo = dynamic(() => import('../pieces/welcome-campo/WelcomeCampo'), { ssr: true });
const CardCampo = dynamic(() => import('../carousel/apartment/CardCampo'), { ssr: true });
const RodapeCampo = dynamic(() => import('../pieces/rodape-campo/RodapeCampo'), { ssr: true });

// ---------------------------------------------------------------------------
// MAPAS DE VARIANTES NOVAS DA HOME (pages/index.tsx)
//
// Chave = valor do respectivo campo `modelo_*` do site; valor = componente da
// variante nova (registrar via `lazySection` de ./types — ver README de fase
// futura). Os pontos de render da home consultam ESTES mapas ANTES dos switches
// legados: se houver entrada, renderiza a variante nova; senão, cai na cadeia
// de sempre.
//
// COMEÇAM VAZIOS DE PROPÓSITO: com os mapas `{}`, todo lookup devolve
// `undefined` e o comportamento dos ~300 sites é IDÊNTICO ao atual (diff
// comportamental NULO). Adicionar uma entrada aqui é o único passo para ligar
// uma variante nova, sem editar os switches legados.
//
// Ex.: NEW_HERO[8] = lazySection<HeroSectionProps>(
//        () => import('../pieces/hero-novo/HeroNovo'),
//      );
// ---------------------------------------------------------------------------

export const NEW_TOPO: Record<number, ComponentType<TopoSectionProps>> = {
  // topo:8 — topo "Autoral" (claro, painel de logo à esquerda, item ativo em
  // bloco sólido e atalho de favoritos). Import ESTÁTICO: o topo é above-the-fold
  // e escolhido em runtime — mesmo motivo do hero (ver bloco abaixo).
  8: TopoAutoral,
  // topo:10 — topo "Aurora" (barra fixa de largura total: transparente sobre o hero da
  // home, sólida na cor1 ao rolar e nas internas; menu em pílulas, favoritos com contador
  // e CTA de WhatsApp em pílula). Import ESTÁTICO pelo mesmo motivo acima. O 9 está
  // reservado numa branch não mergeada (feat/regioes-v3-09set).
  10: TopoAurora,
  // topo:11 — topo "Horizonte" (barra fixa minimalista: some ao rolar para baixo e volta ao
  // subir, vidro com blur ao rolar, pílula que desliza entre os itens e menu em tela cheia
  // com links em cascata no celular — framer-motion). Import ESTÁTICO pelo mesmo motivo acima.
  11: TopoHorizonte,
  // topo:12 — topo "Atelier" (barra editorial em papel: "≡ Menu" · logo central · "Fale conosco"
  // + favoritos; compacta ao rolar com linha de progresso no acento; menu em tela inteira com
  // itens numerados em serifa, contatos e busca por código). next/dynamic com import() literal.
  12: TopoAtelier,
  // topo:13 — topo "Panorama" (barra em PÍLULA de vidro flutuando sobre o hero 16 da home — logo ·
  // menu em caixa alta · "Buscar imóveis"/"Favoritos" com badge/"Fale conosco" — que vira barra
  // branca de largura total ao rolar e nas internas; gaveta lateral em degradê com busca por
  // código, contatos e redes). next/dynamic com import() literal.
  13: TopoPanorama,
  // topo:14 — topo "Larissa" (barra SÓLIDA na cor escura do tenant, fixa, 80px, que some ao rolar para
  // baixo e volta ao subir: logo · menu em Inter 14px só ≥ 1280 com orçamento de caracteres · "Anuncie
  // seu imóvel" · hambúrguer sempre visível → painel de 260px / gaveta no celular). next/dynamic com
  // import() literal.
  14: TopoLarissa,
  // topo:15 — topo "Metrópole" (barra BRANCA de 72px com linha fina, fixa: logo · menu do tenant com "Comprar"/
  // "Alugar" em menus suspensos · "Simular financiamento" com selo NOVO · "Fale conosco" com fone · favoritos com
  // contador; no celular hambúrguer à esquerda, logo central e gaveta). next/dynamic com import() literal.
  15: TopoMetropole,
  // topo:16 — topo "Internacional" (CÁPSULA flutuante fixa com margem 16px, raio 100: transparente sobre o herói
  // da home, base a 85% + blur ao rolar, branca nas internas; some ao descer e volta ao subir; logo · menu em
  // 14px/700 com o telefone na 2ª linha · "Buscar imóveis" · "Todos os imóveis" · favoritos · "Menu ≡" →
  // painel branco em cápsula com links 32px/800, contato, redes e WhatsApp). next/dynamic com import() literal.
  16: TopoInternacional,
  // topo:17 — topo "Norte" (barra TRANSPARENTE e absoluta sobre o herói da home — rola junto, não é fixa —, BRANCA e
  // sticky com linha fina nas internas: logo · menu do tenant em 16/500 com sublinhado de 3px e "Mais ▾" · favoritos ·
  // "Fale conosco"; no celular hambúrguer → gaveta branca de 315px). next/dynamic com import() literal.
  17: TopoNorte,
  // topo:18 — topo "Campo" (barra STICKY de 77px em PAPEL creme a 92% com blur e linha fina: logo · fileira de
  // CATEGORIAS = os tipos de imóvel reais do tenant com ícone 22px e rótulo 11.5 · pílula sólida "Anunciar" · botão
  // CÍRCULO ≡ → painel branco raio 20 de 320px à direita; no celular 2 linhas — pílula "Buscar imóveis…" + ≡ e a
  // fileira de categorias com rolagem horizontal — e o painel vira gaveta de tela cheia). next/dynamic com import() literal.
  18: TopoCampo,
};
export const NEW_HERO: Record<number, ComponentType<HeroSectionProps>> = {
  // busca:8 — hero "Reserva" (alto padrão, dark, acento dourado). Ver README.
  // Import ESTÁTICO (não lazySection) DE PROPÓSITO: o hero é above-the-fold e
  // SSR-crítico. O dynamic(ssr:true) do lazySection embrulha o import() numa
  // variável, então o transform do next/dynamic (SWC) não consegue gerar o
  // loadableGenerated → o chunk do hero NÃO entra no preload do HTML do SSR → o
  // componente escolhido em runtime (NEW_HERO[modelo_busca]) hidrata ANTES do
  // chunk chegar → hydration mismatch (React #418/#423) e o root cai pra
  // client-render. Estático deixa o hero no bundle da home (como os 7 heros
  // legados, todos import estático em pages/index.tsx) e hidrata sem mismatch.
  8: WelcomeReserva,
  // busca:9 — hero "Dwello" (claro/editorial, card de busca bege sobreposto +
  // faixa de estatísticas do tenant). Import ESTÁTICO pelo mesmo motivo acima.
  9: WelcomeDwello,
  // busca:10 — hero "Padrão com busca por IA": o hero 1 (WelcomePieces) inteiro com a
  // barra de frase livre (useBuscaIa, o mesmo do hero 4) no topo do cartão de filtros.
  // Import ESTÁTICO pelo mesmo motivo acima. Erro na barra degrada pro hero 1 puro.
  10: WelcomePadraoIa,
  // busca:11 — hero "Autoral": retrato do corretor em tela cheia, barra de busca
  // clara em uma linha (com busca por Referência) e assinatura manuscrita.
  // Import ESTÁTICO pelo mesmo motivo acima.
  11: WelcomeAutoral,
  // busca:12 — hero "Carrossel de banners com busca por IA": o hero 3 inteiro
  // (carrossel de banners + busca ABAIXO do banner) com a MESMA barra de frase livre
  // do hero 10 no topo do cartão. Existe porque trocar pro 10 tiraria o carrossel de
  // banners e subiria a busca ~410px. Import ESTÁTICO pelo mesmo motivo acima.
  // Erro na barra degrada pro hero 3 puro.
  12: WelcomeCarrosselIa,
  // busca:13 — hero "Aurora": mídia emoldurada (cantos 28px, margem lateral, véu em
  // gradiente), frase do tenant em tipografia grande e busca em CÁPSULA (abas de
  // transação em pílulas + Cidade · Tipo · Quartos + botão redondo de lupa). Import
  // ESTÁTICO pelo mesmo motivo acima.
  13: WelcomeAurora,
  // busca:14 — hero "Horizonte": mídia em TELA CHEIA com Ken Burns e parallax no scroll,
  // título revelado palavra a palavra (CSS, sem esperar JS), busca em painel de vidro com
  // abas de indicador deslizante e "role para baixo" animado. Import ESTÁTICO pelo mesmo
  // motivo acima.
  14: WelcomeHorizonte,
  // busca:15 — hero "Atelier": abertura editorial SEM foto em tela cheia — grade 56/44 com título
  // em serifa revelado palavra a palavra, BUSCA EM FRASE ("Quero comprar um apartamento em Centro
  // até R$ 500 mil") com listboxes acessíveis e mosaico de fotos em colunas que deslizam.
  // next/dynamic com import() literal.
  15: WelcomeAtelier,
  // busca:16 — hero "Panorama": SLIDER DOS IMÓVEIS EM DESTAQUE em tela cheia (foto + véu, "CÓD. -
  // TIPO", título no acento, bairro/cidade, "Mais detalhes" + favorito; fade + zoom lento, autoplay
  // que pausa no hover) com a cápsula de busca em vidro na base (Comprar/Alugar em pílulas, tipo,
  // cidade, "Buscar por código"). next/dynamic com import() literal.
  16: WelcomePanorama,
  // busca:17 — hero "Larissa": herói SÓ DE MÍDIA (vídeo → banner → capa/degradê) e CARTÃO BRANCO de
  // busca sobreposto à base (título em serifa, "Onde?" com bairro/cidade/condomínio/código,
  // Comprar/Alugar em ladrilhos, tipo, valor até, "Buscar" e "Busca avançada"). next/dynamic com
  // import() literal.
  17: WelcomeLarissa,
  // busca:18 — hero "Metrópole": FAIXA de mídia (vídeo → banner "topo" → degradê no acento com a frase do tenant)
  // de ~340px e CARTÃO BRANCO de busca sobreposto à base (abas Comprar/Alugar com sublinhado no acento, campo
  // "Busque pela região, condomínio ou código" + botão "Buscar" + "Filtros" expansível com tipo/quartos/valor,
  // e "Buscar pelo código do imóvel"). next/dynamic com import() literal.
  18: WelcomeMetropole,
  // busca:19 — hero "Internacional": mídia em tela cheia (80vh / 537px) com véu e degradê para o preto, título
  // 68px/800 (frase_busca) + subtítulo (frase_busca_2), abas Comprar/Alugar em pílula segmentada e barra de
  // busca branca em pílula (cidade, bairro, condomínio ou código; sem botão), "Busca avançada"; lábio de 48px
  // da seção seguinte; CardsBusca. next/dynamic com import() literal.
  19: WelcomeInternacional,
  // busca:20 — hero "Norte": mídia em tela cheia (vídeo → banner → capa) com véu do topo, h1 em SERIFA alinhado à
  // esquerda numa coluna de 760px, abas QUADRADAS coladas na caixa BRANCA RETA de busca (Cidade · Bairro · Tipo, os
  // três MULTI) com botão QUADRADO na base do tenant; "Buscar por código" e "Busca avançada". next/dynamic com import() literal.
  20: WelcomeNorte,
  // busca:21 — hero "Campo": SEM foto, fundo de papel clareando para cima com ícones de contorno discretos nas laterais;
  // sobretítulo centrado com os dados do tenant, h1 62/800 com a 2ª metade na cor profunda e traço ondulado, subtítulo;
  // CAIXA DE BUSCA EM PÍLULA 720×67 (Onde multi · Modalidade · Preço, popovers) com botão CÍRCULO 52px na base do
  // tenant; linha de números reais ("N imóveis · N cidades"), "Buscar por código" e "Busca avançada". No celular a caixa
  // vira cartão com os 3 segmentos empilhados e botão largo. next/dynamic com import() literal.
  21: WelcomeCampo,
};
export const NEW_CARD: Record<number, ComponentType<CardSectionProps>> = {
  // card:7 — carrossel "Aurora": trilho com scroll-snap nativo (4/3/2/~1,15 cards),
  // cards brancos de raio 20px com foto 4:3, etiqueta e favorito em vidro e preço em
  // pílula. Abaixo da dobra, mas import estático por simetria com os cards legados
  // (todos no chunk da home).
  7: CardAurora,
  // card:8 — carrossel "Horizonte": trilho arrastável (Swiper) com barra de progresso, cards
  // sem caixa com foto 4:5, preço sobre degradê, entrada em cascata e inclinação 3D no hover.
  // Import estático por simetria com o card 7.
  8: CardHorizonte,
  // card:9 — carrossel "Atelier": cabeçalho "Coleção" + barra fina de progresso, trilho com
  // scroll-snap nativo (4/3/2/~1,2), foto retrato 4:5 com número vazado em serifa, troca para a
  // 2ª foto no hover, preço em serifa e "Cód.". next/dynamic com import() literal.
  9: CardAtelier,
  // card:10 — carrossel "Panorama": seção em degradê encostada à esquerda com os cantos da direita
  // arredondados (96/40/20), cards brancos de raio 20 com foto quadrada, grade de ícones de traço,
  // título/preço no acento e "Detalhes →"; Swiper 3/2/~1,15, bolinhas e seta circular no acento.
  // next/dynamic com import() literal.
  10: CardPanorama,
  // card:11 — vitrine "Larissa": sobretítulo com traço, título serifado em duas tonalidades e "Ver
  // tudo ——"; cards brancos de raio 16 com foto 4/3 (setas no hover, bolinhas), tipo × "COD n", bairro
  // em serifa, atributos com "•", preço e "Ver mais"; Swiper 3/2/~1,1. next/dynamic com import() literal.
  11: CardLarissa,
  // card:12 — card "Metrópole": vitrine em GRADE de 4 (título leve da seção, cards brancos de borda fina e raio
  // 6 com foto 4/3, nome em negrito + coração, tipo, "Área · Dorms · Vagas" com divisórias, endereço com marcador
  // no acento e preço; botão de contorno "Ver mais imóveis" centralizado ao fim). next/dynamic com import() literal.
  12: CardMetropole,
  // card:13 — vitrine "Internacional": título 48px/800 + "Ver todos →" em pílula; GRADE 3/2 com gap 48 (trilho
  // com espiada no celular), até 6 por seção; cards sem caixa — foto 400:270 raio 8 com etiqueta da finalidade,
  // aba preta (selo/tipo) e favorito; preço, endereço e atributos em caixa alta com "•". next/dynamic com import() literal.
  13: CardInternacional,
  // card:14 — vitrine "Norte": h2 sans 32/500 + "Ver todos" sublinhado e setas RETANGULARES 34×24; trilho scroll-snap
  // 3/2/1 com bolinhas; card BRANCO raio 8 com sombra curta, foto 3:2 com carrossel das fotos, etiquetas em pílula
  // (selo sólido na base + finalidade branca), preço 20/500, atributos com divisórias; CARD BASE "Ver todos" no fim
  // do trilho. next/dynamic com import() literal.
  14: CardNorte,
  // card:15 — vitrine "Campo": sobretítulo em versalete com fio ("N IMÓVEIS") + h2 34/800 + pílula "Ver todos →";
  // trilho scroll-snap 3/2/1 (389px, gap 24) com setas em CÍRCULO nas laterais e bolinhas; card raio 20 em cartão
  // quase-branco com borda fina, foto 16:10, etiquetas em pílula (finalidade sólida + tipo contornado), título 2 linhas,
  // pino + "Cidade, UF", preço 19.5/800 na cor profunda com complemento; o carrossel "Destaques" vira SLIDER GRANDE
  // 2.25:1 com véu e autoplay. next/dynamic com import() literal.
  15: CardCampo,
};
export const NEW_RODAPE: Record<number, ComponentType<RodapeSectionProps>> = {
  // rodape:6 — rodapé "Autoral": claro, 4 colunas com divisórias verticais,
  // e-mail revelado no clique e faixa de direitos. Abaixo da dobra, mas import
  // estático por simetria com os outros blocos do modelo (o custo é o mesmo
  // chunk da home, que já carrega os 5 rodapés legados estaticamente).
  6: AutoralFooter,
  // rodape:7 — rodapé "Aurora": faixa-convite em cartão arredondado (cor2) sobreposta
  // ao rodapé, grade de 4 colunas (marca/navegação/contato/institucional) e linha final
  // com direitos, CRECI e selo. Import estático por simetria com o rodapé 6.
  7: AuroraFooter,
  // rodape:8 — rodapé "Horizonte": chamada final com texto em degradê animado, faixa contínua
  // (marquee) de cidades/tipos do tenant, 4 colunas reveladas em cascata e "voltar ao topo"
  // magnético. Import estático por simetria com os rodapés 6 e 7.
  8: HorizonteFooter,
  // rodape:9 — rodapé "Atelier": faixa de convite em serifa + WhatsApp/Ligar/E-mail, colunas
  // (endereço · contato · navegação · buscas populares · redes) reveladas em cascata, NOME DA
  // IMOBILIÁRIA GIGANTE revelado por máscara e linha final com "voltar ao topo" à esquerda.
  // next/dynamic com import() literal.
  9: AtelierFooter,
  // rodape:10 — rodapé "Panorama": bloco em degradê com o canto superior esquerdo arredondado
  // (100/40/20), colunas marca (logo em placa branca, legais, redes) · unidades/filiais · atalhos em
  // tiles · buscas populares; linha final com "voltar ao topo" à esquerda. next/dynamic com import() literal.
  10: PanoramaFooter,
  // rodape:11 — rodapé "Larissa": fundo na cor escura do tenant em 3 faixas — chamada em serifa +
  // contato (WhatsApp/telefone) · logo em placa clara + redes em círculos + navegação · legal.
  // next/dynamic com import() literal.
  11: LarissaFooter,
  // rodape:12 — rodapé "Metrópole": faixa clara de SERVIÇOS (4 cartões: anuncie, simule, fale com um corretor,
  // favoritos), FAIXA no acento com o botão redondo "voltar ao topo", colunas brancas (logo · "A <empresa>" ·
  // Serviços · Redes sociais · Fale conosco) e linha legal (© empresa · CRECI · CNPJ). next/dynamic com import() literal.
  12: MetropoleFooter,
  // rodape:13 — rodapé "Internacional": faixa de contato na base com letra-marca gigante + cartão branco de
  // contatos · área branca com pílulas, links grandes 24px/800 e colunas Imóveis/Cidades · barra logo + © + redes
  // em círculos · legal em itálico. next/dynamic com import() literal.
  13: InternacionalFooter,
  // rodape:14 — rodapé "Norte": fundo profundo na cor do tenant de ponta a ponta, linha "Cidades:", colunas com título
  // em SERIFA 24/400 (Empresa · Imóveis · Contato) e links 16/400, redes empilhadas à direita e bloco legal (logo,
  // ©, CRECI/CNPJ, links legais). next/dynamic com import() literal.
  14: NorteFooter,
  // rodape:15 — rodapé "Campo": "Pesquisas mais populares" em chips de pílula no papel; faixa SÓLIDA na base do
  // tenant com "Voltar para o topo" em pílula contornada branca, logo, colunas Onde estamos · Horário & contato ·
  // Institucional · Redes (círculos 40), linha de SEO, filiais e linha final (©, CRECI, legais, selo).
  // next/dynamic com import() literal.
  15: RodapeCampo,
};
export const NEW_EMPRESA: Record<number, ComponentType<EmpresaSectionProps>> = {
  // empresa:3 — "Nossa Empresa com faixa" do modelo Autoral: a arte do banner "home"
  // em largura TOTAL da página, encostada no texto institucional em colunas. Enquanto
  // esta variante estiver ligada, o slot `banner` da home não renderiza (a arte foi
  // movida para cá, não duplicada). Abaixo da dobra, mas import estático por simetria
  // com as demais peças do modelo — o chunk da home já carrega as variantes legadas.
  3: EmpresaAutoral,
};
export const NEW_DEPOIMENTO: Record<number, ComponentType<DepoimentoSectionProps>> = {};
export const NEW_EQUIPE: Record<number, ComponentType<EquipeSectionProps>> = {};
